import React, {
  PropsWithChildren,
  useContext,
  useMemo,
  useRef,
  useState,
} from "react";

import { v4 as uuid } from "uuid";
import NotificationAlerts from "../components/Notifications/NotificationAlerts";
import NotificationAlert from "../components/Notifications/NotificationAlert";

type notifierShape = {
  showError: $TSFixMeFunction;
  showWarning: $TSFixMeFunction;
  showSuccess: $TSFixMeFunction;
};

type WithNotifierType = {
  notifier: notifierShape;
};

const NotifierContext = React.createContext<WithNotifierType | null>(null);

const TIME_VISIBLE = 4000;

interface NotifierContextProviderProps {
  testNotifier?: $TSFixMe;
}

function NotifierContextProvider({
  children,
  testNotifier,
}: Readonly<PropsWithChildren<NotifierContextProviderProps>>) {
  const notificationsRef = useRef([]);
  const [notifications, setNotifications] = useState([]);

  const removeNotification = (notification: $TSFixMe) => {
    notificationsRef.current = notificationsRef.current.filter(
      (n) => n !== notification,
    );
    setNotifications([...notificationsRef.current]);
  };

  const showNotification = (
    type: $TSFixMe,
    message: $TSFixMe,
    dismissAfter: $TSFixMe,
  ) => {
    const notification = {
      id: uuid(),
      type,
      message,
    };

    // @ts-expect-error TS(2322) FIXME: Type '{ id: any; type: any; message: any; }' is no... Remove this comment to see the full error message
    notificationsRef.current = [notification, ...notificationsRef.current];
    setNotifications([...notificationsRef.current]);
    setTimeout(() => removeNotification(notification), dismissAfter);
  };

  const context = useMemo(() => {
    let notifier;
    if (testNotifier) {
      notifier = testNotifier;
    } else {
      notifier = {
        showError: (message: $TSFixMe, dismissAfter = TIME_VISIBLE) =>
          showNotification("error", message, dismissAfter),
        showWarning: (message: $TSFixMe, dismissAfter = TIME_VISIBLE) =>
          showNotification("warning", message, dismissAfter),
        showSuccess: (message: $TSFixMe, dismissAfter = TIME_VISIBLE) =>
          showNotification("success", message, dismissAfter),
      };
    }
    // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
    global.notifier = notifier;
    return { notifier };
  }, []);
  return (
    <NotifierContext.Provider value={context}>
      <NotificationAlerts>
        {notifications.map((notification) => (
          <NotificationAlert
            key={(notification as $TSFixMe).id}
            type={(notification as $TSFixMe).type}
            message={(notification as $TSFixMe).message}
            onClose={() => removeNotification(notification)}
          />
        ))}
      </NotificationAlerts>
      {children}
    </NotifierContext.Provider>
  );
}

const withNotifier = <T extends WithNotifierType = WithNotifierType>(
  ChildComponent: React.ComponentType<T>,
) => {
  function ConnectedComponent(
    props: Readonly<Omit<T, keyof WithNotifierType>>,
  ) {
    return (
      <NotifierContext.Consumer>
        {(context) => {
          // istanbul ignore next
          if (!context) {
            throw new Error(
              "withNotifier must be used inside a NotifierContextProvider",
            );
          }
          return <ChildComponent {...(props as T)} {...context} />;
        }}
      </NotifierContext.Consumer>
    );
  }
  ConnectedComponent.displayName =
    ChildComponent.displayName ?? ChildComponent.name;
  return ConnectedComponent;
};

const useNotifier = () => {
  const context = useContext(NotifierContext);
  // istanbul ignore next
  if (!context) {
    throw new Error(
      "useNotifier must be used inside a NotifierContextProvider",
    );
  }
  return context.notifier;
};

export {
  useNotifier,
  type notifierShape,
  NotifierContextProvider,
  withNotifier,
};
